/* NoSEO Racing Theme — global.js */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Geld-Formatierung ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    format = format || (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} €';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }

    var match = format.match(placeholderRegex);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  /* ---------- Warenkorb-Drawer ---------- */
  var drawer = $('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.classList.add('drawer-open');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', !count);
    });
  }

  function cartSectionIds() {
    var ids = ['cart-drawer'];
    var mainCart = $('[data-main-cart]');
    if (mainCart && mainCart.dataset.sectionId) ids.push(mainCart.dataset.sectionId);
    return ids;
  }

  function renderSections(sectionsHtml) {
    if (!sectionsHtml) return false;
    Object.keys(sectionsHtml).forEach(function (id) {
      var html = sectionsHtml[id];
      if (!html) return;
      var dom = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        var source = dom.querySelector('#CartDrawerInner');
        var target = $('#CartDrawerInner');
        if (source && target) {
          target.innerHTML = source.innerHTML;
          target.dataset.itemCount = source.dataset.itemCount || '0';
          updateCartCount(parseInt(source.dataset.itemCount, 10) || 0);
        }
      } else {
        var srcSection = dom.querySelector('[data-section-id="' + id + '"]');
        var targetSection = document.querySelector('[data-section-id="' + id + '"]');
        if (srcSection && targetSection) targetSection.innerHTML = srcSection.innerHTML;
      }
    });
    return true;
  }

  function changeCartLine(line, quantity) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: cartSectionIds(),
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        renderSections(data.sections);
        if (typeof data.item_count === 'number') updateCartCount(data.item_count);
      })
      .catch(function (err) { console.error('Cart error:', err); });
  }

  /* ---------- Globale Klick-Handler ---------- */
  document.addEventListener('click', function (e) {
    var cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle) { e.preventDefault(); openDrawer(); return; }

    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

    var change = e.target.closest('[data-cart-change]');
    if (change) {
      e.preventDefault();
      change.classList.add('is-busy');
      changeCartLine(parseInt(change.dataset.line, 10), parseInt(change.dataset.quantity, 10));
      return;
    }

    var plus = e.target.closest('[data-qty-plus]');
    var minus = e.target.closest('[data-qty-minus]');
    if (plus || minus) {
      var wrap = (plus || minus).closest('[data-qty]');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var current = parseInt(input.value, 10) || 1;
      var min = input.hasAttribute('data-min-zero') ? 0 : 1;
      input.value = Math.max(min, current + (plus ? 1 : -1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var container = thumb.closest('[data-product-container]') || document;
      var main = container.querySelector('[data-main-image]');
      if (!main) return;
      if (thumb.dataset.src) main.src = thumb.dataset.src;
      if (thumb.dataset.srcset) main.setAttribute('srcset', thumb.dataset.srcset);
      var thumbImg = thumb.querySelector('img');
      if (thumbImg && thumbImg.alt) main.alt = thumbImg.alt;
      $$('[data-thumb]', container).forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
      return;
    }

    var recover = e.target.closest('[data-toggle-recover]');
    if (recover) {
      e.preventDefault();
      var auth = document.querySelector('[data-auth]');
      if (auth) auth.classList.toggle('show-recover');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      document.body.classList.remove('menu-open');
      var searchBar = $('[data-search-bar]');
      if (searchBar) searchBar.hidden = true;
    }
  });

  /* ---------- In den Warenkorb (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]');
    var errorEl = form.querySelector('[data-form-error]');
    if (errorEl) errorEl.hidden = true;
    if (button) { button.classList.add('is-busy'); button.setAttribute('disabled', ''); }

    var formData = new FormData(form);
    formData.append('sections', cartSectionIds().join(','));
    formData.append('sections_url', window.location.pathname);

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          var msg = data.description || data.message || 'Fehler beim Hinzufügen.';
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
          return;
        }
        var rendered = renderSections(data.sections);
        if (!rendered) {
          fetch(window.routes.cart_url + '.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) { updateCartCount(cart.item_count); });
        }
        openDrawer();
      })
      .catch(function (err) { console.error('Add to cart error:', err); })
      .then(function () {
        if (button) { button.classList.remove('is-busy'); button.removeAttribute('disabled'); }
      });
  });

  /* ---------- Change-Handler (Warenkorb-Menge, Notiz, Sortierung) ---------- */
  document.addEventListener('change', function (e) {
    var lineInput = e.target.closest('input[data-line]');
    if (lineInput) {
      changeCartLine(parseInt(lineInput.dataset.line, 10), Math.max(0, parseInt(lineInput.value, 10) || 0));
      return;
    }

    var note = e.target.closest('[data-cart-note]');
    if (note) {
      fetch(window.routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
      return;
    }

    var sort = e.target.closest('[data-sort-select]');
    if (sort) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  /* ---------- DOM-Ready ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    /* Header */
    var menuToggle = $('[data-menu-toggle]');
    if (menuToggle) {
      menuToggle.addEventListener('click', function () {
        var open = document.body.classList.toggle('menu-open');
        menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    var searchBar = $('[data-search-bar]');
    $$('[data-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!searchBar) return;
        searchBar.hidden = !searchBar.hidden;
        if (!searchBar.hidden) {
          var input = $('[data-search-input]', searchBar);
          if (input) input.focus();
        }
      });
    });

    /* Varianten-Auswahl */
    $$('[data-product-container]').forEach(function (container) {
      var jsonEl = container.querySelector('[data-product-json]');
      if (!jsonEl) return;
      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

      var selects = $$('[data-option-select]', container);
      if (!selects.length) return;

      var idInput = container.querySelector('input[name="id"]');
      var addBtn = container.querySelector('[data-add-button]');
      var addBtnText = container.querySelector('[data-add-button-text]');
      var priceWrap = container.querySelector('[data-price-wrapper]');
      var strings = (window.theme && window.theme.strings) || {};

      function currentVariant() {
        var selected = selects.map(function (s) { return s.value; });
        return product.variants.find(function (v) {
          return selected.every(function (val, i) { return v.options[i] === val; });
        });
      }

      function onChange() {
        var variant = currentVariant();
        if (!variant) {
          if (addBtn) addBtn.setAttribute('disabled', '');
          if (addBtnText) addBtnText.textContent = strings.unavailable || 'Nicht verfügbar';
          return;
        }
        if (idInput) idInput.value = variant.id;

        if (addBtn) {
          if (variant.available) {
            addBtn.removeAttribute('disabled');
            if (addBtnText) addBtnText.textContent = strings.addToCart || 'In den Warenkorb';
          } else {
            addBtn.setAttribute('disabled', '');
            if (addBtnText) addBtnText.textContent = strings.soldOut || 'Ausverkauft';
          }
        }

        if (priceWrap) {
          var priceEl = priceWrap.querySelector('[data-price]');
          var compareEl = priceWrap.querySelector('[data-compare-price]');
          var priceBox = priceWrap.querySelector('.price');
          var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          if (priceEl) priceEl.textContent = formatMoney(variant.price);
          if (compareEl) {
            compareEl.hidden = !onSale;
            compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
          }
          if (priceBox) priceBox.classList.toggle('price--on-sale', !!onSale);
        }

        if (variant.featured_media && variant.featured_media.id) {
          var mediaThumb = container.querySelector('[data-thumb][data-media-id="' + variant.featured_media.id + '"]');
          if (mediaThumb) mediaThumb.click();
        }

        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (err) { /* noop */ }
      }

      selects.forEach(function (s) { s.addEventListener('change', onChange); });
    });

    /* Produkt-Empfehlungen */
    $$('[data-related-products]').forEach(function (el) {
      var url = el.dataset.url;
      if (!url) return;
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var dom = new DOMParser().parseFromString(text, 'text/html');
          var inner = dom.querySelector('[data-related-products]');
          if (inner && inner.innerHTML.trim().length) el.innerHTML = inner.innerHTML;
        })
        .catch(function () { /* noop */ });
    });

    /* Adressen: Länder/Provinzen */
    $$('[data-address-country]').forEach(function (select) {
      var form = select.closest('form') || document;
      var provinceWrap = form.querySelector('[data-province-wrap]');
      var provinceSelect = form.querySelector('[data-address-province]');

      function updateProvinces() {
        if (!provinceSelect) return;
        var option = select.options[select.selectedIndex];
        var provinces = [];
        try { provinces = JSON.parse(option.getAttribute('data-provinces') || '[]'); } catch (err) { /* noop */ }
        provinceSelect.innerHTML = '';
        if (!provinces.length) {
          if (provinceWrap) provinceWrap.hidden = true;
          return;
        }
        if (provinceWrap) provinceWrap.hidden = false;
        provinces.forEach(function (p) {
          var o = document.createElement('option');
          o.value = p[0];
          o.textContent = p[1];
          if (p[0] === provinceSelect.dataset.default) o.selected = true;
          provinceSelect.appendChild(o);
        });
      }

      if (select.dataset.default) {
        $$('option', select).forEach(function (o) {
          if (o.value === select.dataset.default) o.selected = true;
        });
      }
      updateProvinces();
      select.addEventListener('change', updateProvinces);
    });

    if (window.location.hash === '#recover') {
      var auth = document.querySelector('[data-auth]');
      if (auth) auth.classList.add('show-recover');
    }
  });
})();
